import { State } from './types';

const mutations = {
  setEditUrl(state: State, editUrl: string) {
    state.editUrl = editUrl;
  },
  setClipId(state: State, clipId: string) {
    state.clipId = clipId;
  },
  setIsCLVideoReady(state: State, isCLVideoReady: boolean) {
    state.isCLVideoReady = isCLVideoReady;
  },
  setClipError(state: State, clipError: string) {
    state.clipError = clipError;
  },
  resetState(state: State) {
    state.editUrl = undefined;
    state.clipId = undefined;
    state.isCLVideoReady = undefined;
    state.clipError = null;
  }
};

export default mutations;
